import {
  GameLauncherService,
  IConstructorPayload,
} from '../services/gamelauncher.service';
import { Plugin } from '@nuxt/types';

type TInit = () => GameLauncherService;
declare module 'vue/types/vue' {
  // tslint:disable-next-line: interface-name
  interface Vue {
    $initGameLauncherService: TInit;
  }
}

declare module '@nuxt/types' {
  // tslint:disable-next-line: interface-name
  interface NuxtAppOptions {
    $initGameLauncherService: TInit;
  }

  // tslint:disable-next-line: interface-name
  interface Context {
    $initGameLauncherService: TInit;
  }
}

declare module 'vuex/types/index' {
  // tslint:disable-next-line: interface-name
  interface Store<S> {
    $initGameLauncherService: TInit;
  }
}

const initGameLauncherService: Plugin = (ctx, inject) => {
  let inst: GameLauncherService | undefined;

  const init: TInit = () => {
    if (inst instanceof GameLauncherService) {
      return inst;
    }

    const gameLauncherServicePayload: IConstructorPayload = {
      getUa: () => ctx.app.$ua,
    };

    inst = new GameLauncherService(gameLauncherServicePayload);
    return inst;
  };

  inject('initGameLauncherService', init);
};

export default initGameLauncherService;
